module.exports = __webpack_public_path__ + "img/jiaju3.6f9bfedf.png";